exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".question {\n  margin-bottom: 4rem; }\n\n.decline {\n  margin-right: 3.8rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/app/shared/confirm-modal/confirm-modal.component.scss
// module id = ../../../../../src/app/shared/confirm-modal/confirm-modal.component.scss
// module chunks = 2